import { useState } from "react";
import { PasswordInput } from "@/components/ui/password-input";
import PasswordStrengthIndicator from "./PasswordStrengthIndicator";

interface SecurePasswordInputProps {
  id?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  className?: string;
  autoComplete?: string;
  showStrengthIndicator?: boolean;
  personalInfo?: {
    name?: string;
    email?: string;
    phone?: string;
    company?: string;
  };
}

const SecurePasswordInput = ({
  id,
  placeholder = "••••••••",
  value,
  onChange,
  required,
  className,
  autoComplete = "new-password",
  showStrengthIndicator = false,
  personalInfo
}: SecurePasswordInputProps) => {
  const [showStrength, setShowStrength] = useState(false);

  // Create a synthetic event for the password input
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        name: id, // Use the id as the name for the parent form
        value: e.target.value
      }
    };
    onChange(syntheticEvent);
  };

  const handleFocus = () => {
    if (showStrengthIndicator) {
      setShowStrength(true);
    }
  };

  const handleBlur = () => {
    // Keep showing strength indicator if there's content or if it should always show
    if (!showStrengthIndicator || !value) {
      setShowStrength(false);
    }
  };

  return (
    <div className="space-y-2">
      <PasswordInput
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={handlePasswordChange}
        required={required}
        className={className}
        autoComplete={autoComplete}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      
      {(showStrength || (showStrengthIndicator && value)) && (
        <PasswordStrengthIndicator 
          password={value} 
          personalInfo={personalInfo}
        />
      )}
    </div>
  );
};

export default SecurePasswordInput;
